import { NgModule } from '@angular/core';

import { HlmToasterComponent } from './lib/hlm-toaster.component';

export * from './lib/hlm-toaster.component';

export const HlmToasterImports = [HlmToasterComponent] as const;

@NgModule({
	imports: [...HlmToasterImports],
	exports: [...HlmToasterImports],
})
export class HlmToasterModule {}
